



























import Vue from 'vue';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';
import { map, find } from 'lodash';
import { EventBus } from '@/plugins/event-bus';
import MobileNavigationDrawer from '@/components/header/MobileNavigationDrawer.vue'; // @ is an alias to /src
import localeMessages from '@/plugins/i18n/locale-messages';
import { MUTATE_LOCALE } from '../../store/modules/localization';

@Component({
  components: {
    MobileNavigationDrawer,
  },
})
export default class Header extends Vue {
    // init data
    public fixed: boolean = false;
    public right: boolean = true;
    public title: string = 'LUX TAG';
    public showDrawer: boolean = false;
    public showAvatar: boolean = true;
    public showDrowpdownLost = false;
    public activeTab = 0;
    public hideSlider = false;
    public showTabActiveColor = true;

    public menuLocalizations = [
        { title: 'Click Me' },
        { title: 'Click Me' },
        { title: 'Click Me' },
        { title: 'Click Me 2' }
    ];

    public NavigationList: any[] = [
        {
            key: 1,
            name: 'FAQ',
            path: '/faq',
            outline: true,
            round: true,
            color: 'primary',
            class: {
                'white--text': false,
                'hidden-xs-only': true,
            },
        },
    ];


    public created() {
        EventBus.$on('change-active-tab', (activeTab: number) => {
            this.activeTab = activeTab;
        });

        EventBus.$on('change-hide-slider', (hideSlider: boolean) => {
            this.hideSlider = hideSlider;
        });

        EventBus.$on('change-show-tab-active-color', (showTabActiveColor: boolean) => {
            this.showTabActiveColor = showTabActiveColor;
        });
    }

    public onChangeLanguageClick(locale: any) {
        this.$store.commit(MUTATE_LOCALE, locale.value);
        this.$i18n.locale = locale.value;
    }

    public onTabNavigationClick(key: string) {
        switch (key) {
            case 'home':
                break;
            case 'login':
                break;
            case 'login':
                break;

        }
    }

    public onNavigationClick(path: string) {
        this.$router.push(path);
    }

    public goHome() {
        this.$router.push('/');
    }

    get localizeList() {
        return [
            {
                value: 'us',
                name: 'English',
                label:  'English / English',
            },
            {
                value: 'my',
                name: 'Bahasa Malaysia',
                label:  'Malay Language / Bahasa Malaysia',
            }
        ];
    }

    get activeLocale() {
        const theLocale = find(this.localizeList, (loc) => loc.value === this.locale);
        if (theLocale) {
            return theLocale;
        } else {
            return this.localizeList[0];
        }
    }

    get locale(): string {
        return this.$store.getters.locale;
    }

    get isShowNavigation(): any {
        return this.$store.getters.getShowNavigation;
    }
}
